import React from "react";
import { useTranslation } from "react-i18next";

export default function Unauthorized(){
    const {t} = useTranslation();
    return <h1>{t("unauthorized")}</h1>
}